import React from 'react';
import _ from 'lodash';
import Item from './MediaBarItem';
import styles from './css/MediaBar.styl';
import {
  bindMethods,
  setRef,
} from '../../../../shared/utilities/componentHelpers';

export default class MediaBar extends React.Component {
  static propTypes = {
    handleEditOverlay: React.PropTypes.func,
    mediaCollection: React.PropTypes.array,
    showCollection: React.PropTypes.bool,
  };

  /**
   * MediaBar Component constructor
   * @return {Undefined} Returns nothing
   */
  constructor() {
    super();

    this.mediaBarRef = null;
    this.setMediaBarRef = _.partial(setRef, _, 'mediaBarRef', this);

    bindMethods(this, ['getRef']);
  }

  /**
   * Getter for mediaBarRef
   * @return {Object} DOM Element
   */
  getRef() {
    return this.mediaBarRef;
  }

  /**
   * React Component render.
   * @return {JSX} MediaBar rendered.
   */
  render() {
    const {handleEditOverlay, mediaCollection, showCollection} = this.props;

    return _.size(mediaCollection) !== 0 && showCollection ? (
      <div className={styles.MediaBar} ref={this.setMediaBarRef}>
        {mediaCollection.map((item, index) => (
          <Item
            caption={item.caption}
            filename={item.filename}
            handleEditOverlay={handleEditOverlay}
            key={index}
            mediaType={item.mediaType}
            parentRefGetter={this.getRef}
            url={item.url}
          />
        ))}
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/MediaBar.js